export enum AnalyticsEventName {
  NEW_SESSION = 'new_session',

  VISIT = 'visit',

  MODAL__REGISTRATION__FORM__APPEARANCE = 'modal__registration__form__appearance',
  MODAL__REGISTRATION__FORM__TOUCHED = 'modal__registration__form__touched',
  MODAL__REGISTRATION__FORM__ERROR = 'modal__registration__form__error',
  MODAL__REGISTRATION__FORM__SUCCESS = 'modal__registration__form__success',
  MODAL__REGISTRATION__FORM__SUBMIT = 'modal__registration__form__submit',

  MODAL__TERMS_AND_SERVICES__SHOW = 'modal__terms_and_services__show',
  MODAL__TERMS_AND_SERVICES__SUCCESS = 'modal__terms_and_services__success',
  MODAL__TERMS_AND_SERVICES__AGREE_BUTTON__CLICK = 'modal__terms_and_services__agree_button__click',
  MODAL__TERMS_AND_SERVICES__AGREE_BUTTON__CLICK__ERROR = 'modal__terms_and_services__agree_button__click__error',

  MODAL__LOGIN__FORM__ERROR = 'modal__login__form__error',
  MODAL__LOGIN__FORM__SUCCESS = 'modal__login__form__success',

  MODAL__FULL_INFORMATION__FORM__APPEARANCE = 'modal__full_information__form__appearance',
  MODAL__FULL_INFORMATION__FORM__TOUCHED = 'modal__full_information__form__touched',
  MODAL__FULL_INFORMATION__FORM__SUBMIT = 'modal__full_information__form__submit',
  MODAL__FULL_INFORMATION__FORM__ERROR = 'modal__full_information__form__error',
  MODAL__FULL_INFORMATION__FORM__SUCCESS = 'modal__full_information__form__success',

  MODAL__DEPOSIT__FORM__APPEARANCE = 'modal__deposit__form__appearance',
  MODAL__DEPOSIT__FORM__TOUCHED = 'modal__deposit__form__touched',
  MODAL__DEPOSIT__FORM__ERROR = 'modal__deposit__form__error',
  MODAL__DEPOSIT__FORM__SUCCESS = 'modal__deposit__form__success',
  MODAL__DEPOSIT__PROMO_CODE_FORM__TOUCHED = 'modal__deposit__promo_code_form__touch',
  MODAL__DEPOSIT__PROMO_CODE_FORM__ADD = 'modal__deposit__promo_code_form__add',
  MODAL__DEPOSIT__PROMO_CODE_FORM__CANCEL = 'modal__deposit__promo_code_form__cancel',
  MODAL__DEPOSIT__SHORT_AMOUNT__CLICK = 'modal__deposit__short_amount__click',
  MODAL__DEPOSIT__CAN_ISSUE_BONUSES__CLICK = 'modal__deposit__can_issue_bonuses__click',

  MODAL__WITHDRAW__FORM__APPEARANCE = 'modal__withdraw__form__appearance',
  MODAL__WITHDRAW__FORM__REQUEST = 'modal__withdraw__form__request',

  MODAL__MOBILE_APP_PAGE__ANDROID_APP_ICON__LINK__CLICK = 'modal__mobile_app_page__android_app_icon__link__click',

  NAVBAR__MENU_ITEM__LINK__CLICK = 'navbar__menu_item__link__click',
  NAVBAR__MENU_ITEM__BUTTON_CS__CLICK = 'navbar__menu_item__button_cs__click',
  NAVBAR__MENU_ITEM__BUTTON_LOGOUT__CLICK = 'navbar__menu_item__button_logout__click',

  LOBBY__SEARCH__INPUT__CLICK = 'lobby__search__input__click',
  LOBBY__PROMO_SLIDER__DEPOSIT_BANNER__BUTTON__CLICK = 'lobby__deposit_banner__button__click',
  LOBBY__PROMO_SLIDER__BANNER__CLICK = 'lobby__promo_slider__banner__click',
  LOBBY__FILTER__BUTTON__CLICK = 'lobby__filter__button__click',
  LOBBY__NEW__WINNERS__CLICK = 'lobby__new__winners__click',

  SEARCH__GAMES__RESULT_SUCCESS__APPEARANCE = 'search__games__result_success__appearance',
  SEARCH__GAMES__RESULT_FAILURE__APPEARANCE = 'search__games__result_failure__appearance',
  SEARCH__GAMES__SIMILAR_RESULT_SUCCESS__APPEARANCE = 'search__games__similar_result_success__appearance',
  SEARCH__GAMES__SIMILAR_RESULT_FAILURE__APPEARANCE = 'search__games__similar_result_failure__appearance',
  SEARCH__GAMES__INPUT__TOUCHED = 'search__games__input__touch',
  SEARCH__CATEGORIES__CARD__CLICK = 'search__categories__card__click',
  SEARCH__CATEGORIES__ARROWS__CLICK = 'search__categories__arrows__click',
  SEARCH__PROVIDER__CARD__CLICK = 'search__provider__card__click',
  SEARCH__THEME__CARD__CLICK = 'search__theme__card__click',
  SEARCH__THEME__ARROWS__CLICK = 'search__theme__arrows__click',

  GAMES__SHOW_MORE__BUTTON__CLICK = 'games__show_more__button__click',
  GAMES__SHOW_MORE__LOAD_ON_SCROLL = 'games__show_more__load_on_scroll',

  GAME_OPEN__DEMO_REAL__TOGGLE = 'game_open__demo_real__toggle',
  GAME_OPEN__MOBILE_ACTIONS_PANEL_BUTTON__CLICK = 'game_open__mobile_actions_panel_button__click',

  GAME_OPEN__WAGER_LABEL__CLICK = 'game_open__wager_label__click',

  SLIDER__SEE_ALL__BUTTON__CLICK = 'slider__see_all__button__click',
  SLIDER__GAME_CARD__BUTTON__CLICK = 'slider__game_card__button__click',

  GAME__ADD_TO_FAVORITES_BUTTON__CLICK = 'game__add_to_favorites_button__click',
  GAME__FILTER__BUTTON__CLICK = 'game__filter__button__click',

  EMAIL_CONFIRMATION_POPUP__BUTTON_CLOSE__CLICK = 'email_confirmation_popup__button_close__click',
  EMAIL_CONFIRMATION_POPUP__FIRST_APPEARANCE = 'email_confirmation_popup__first_appearance',
  EMAIL_CONFIRMATION_POPUP__SUBSEQUENT_APPEARANCE = 'email_confirmation_popup__subsequent_appearance',
  EMAIL_CONFIRMED = 'email_confirmed',

  FAVORITE_GAMES__PLUG_WITH_LINK__CLICK = 'favorite_games__plug_with_link__click',

  TABBAR__MENU_BUTTON__CLICK = 'tabbar__menu_button__click',
  TABBAR__SEARCH_BUTTON__CLICK = 'tabbar__search_button__click',
  TABBAR__WHEEL_BUTTON__CLICK = 'tabbar__wheel_button__click',
  TABBAR__PROMO_BUTTON__CLICK = 'tabbar__promo_button__click',
  TABBAR__HOME_BUTTON__CLICK = 'tabbar__home_button__click',
  TABBAR__LOGIN_BUTTON__CLICK = 'tabbar__login_button__click',
  TABBAR__REGISTER_BUTTON__CLICK = 'tabbar__register_button__click',
  TABBAR__TOURNAMENTS_BUTTON__CLICK = 'tabbar__tournaments_button__click',

  MOBILE_APP_PAGE__VISIT = 'mobile_app_page__visit',
  MOBILE_APP_PAGE__ANDROID_APP_ICON__LINK__CLICK = 'mobile_app_page__android_app_icon__link__click',
  MOBILE_APP_PAGE__IOS_APP_ICON__LINK__CLICK = 'mobile_app_page__ios_app_icon__link__click',

  HEADER__LOGO__CLICK = 'header__logo__click',
  HEADER__CURRENCY_SELECT__CLICK = 'header__currency_select__click',
  HEADER__DEPOSIT_BUTTON__CLICK = 'header__deposit_button__click',

  FOOTER__MOBILE_APP__LINK__CLICK = 'footer__mobile_app__link__click',
  FOOTER__ANDROID_APP_ICON__LINK__CLICK = 'footer__android_app_icon__link__click',
  FOOTER__IOS_APP_ICON__LINK__CLICK = 'footer__ios_app_icon__link__click',

  PROMO__PROMOCODE_ACTIVATION__SUCCESS = 'promo__promocode_activation__success',
  PROMO__PROMOCODE_ACTIVATION__FAILURE = 'promo__promocode_activation__failure',

  PROMO__TAB__SELECTION = 'promo__tab__selection',

  PROMO__BONUS_CARD__ACTIVATE__SUCCESS = 'promo__bonus_card__activate__success',
  PROMO__BONUS_CARD__ACTIVATE__FAILURE = 'promo__bonus_card__activate__failure',
  PROMO__BONUS_CARD__CANCEL__SUCCESS = 'promo__bonus_card__cancel__success',
  PROMO__BONUS_CARD__CANCEL__FAILURE = 'promo__bonus_card__cancel__failure',
  PROMO__BONUS_CARD__PLAY = 'promo__bonus_card__play',

  PROMO__EXCHANGE_CP_MODAL__EXCHANGE__SUCCESS = 'promo__exchange_cp_modal__exchange__success',
  PROMO__EXCHANGE_CP_MODAL__EXCHANGE__FAILURE = 'promo__exchange_cp_modal__exchange__failure',
}

type CommonAttributes = {
  sessionId?: string; // field is required for the backend
  eventId?: string;
  userId?: number;
  email?: string;
  additionalData?: string;
  createdAt?: number; // field is required for the backend
  updatedAt?: number; // field is required for the backend
};

export type EventWithPayload =
  | {
      name: AnalyticsEventName.NEW_SESSION;
      attributes: CommonAttributes & {
        device?: {
          deviceType?: string;
          deviceName?: string;
          os?: string;
          osVersion?: string;
          browser?: string;
          browserVersion?: string;
          screenSizeWidth?: number;
          screenSizeHeight?: number;
          internetSpeedMbps?: number;
        };
        location?: {
          countryCode?: string;
          defaultCurrency?: string;
          ip?: string;
          regionCode?: string;
        };
      };
    }
  | {
      name: AnalyticsEventName.VISIT;
      attributes?: CommonAttributes & { stag?: string; url?: string };
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__FORM__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__FORM__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__FORM__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PROMO_CODE_FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PROMO_CODE_FORM__ADD;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__PROMO_CODE_FORM__CANCEL;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__SHORT_AMOUNT__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__DEPOSIT__CAN_ISSUE_BONUSES__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__FULL_INFORMATION__FORM__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__FULL_INFORMATION__FORM__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__FULL_INFORMATION__FORM__SUBMIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__FULL_INFORMATION__FORM__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__FULL_INFORMATION__FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__SUBMIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__TERMS_AND_SERVICES__SHOW;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__TERMS_AND_SERVICES__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__TERMS_AND_SERVICES__AGREE_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__TERMS_AND_SERVICES__AGREE_BUTTON__CLICK__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__REGISTRATION__FORM__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.NAVBAR__MENU_ITEM__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.NAVBAR__MENU_ITEM__BUTTON_CS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.NAVBAR__MENU_ITEM__BUTTON_LOGOUT__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__SEARCH__INPUT__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__PROMO_SLIDER__DEPOSIT_BANNER__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__FILTER__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__PROMO_SLIDER__BANNER__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.LOBBY__NEW__WINNERS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__GAMES__RESULT_SUCCESS__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__GAMES__RESULT_FAILURE__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__GAMES__SIMILAR_RESULT_FAILURE__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__GAMES__SIMILAR_RESULT_SUCCESS__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__GAMES__INPUT__TOUCHED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__CATEGORIES__CARD__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__CATEGORIES__ARROWS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__THEME__CARD__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__THEME__ARROWS__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SEARCH__PROVIDER__CARD__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAMES__SHOW_MORE__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAMES__SHOW_MORE__LOAD_ON_SCROLL;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_OPEN__DEMO_REAL__TOGGLE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_OPEN__MOBILE_ACTIONS_PANEL_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME_OPEN__WAGER_LABEL__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SLIDER__SEE_ALL__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.SLIDER__GAME_CARD__BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME__ADD_TO_FAVORITES_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMATION_POPUP__BUTTON_CLOSE__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMATION_POPUP__FIRST_APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMATION_POPUP__SUBSEQUENT_APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.EMAIL_CONFIRMED;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.FAVORITE_GAMES__PLUG_WITH_LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__MENU_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__SEARCH_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__WHEEL_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__PROMO_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__HOME_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__LOGIN_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__REGISTER_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.TABBAR__TOURNAMENTS_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PAGE__VISIT;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PAGE__ANDROID_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MOBILE_APP_PAGE__IOS_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.HEADER__LOGO__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.HEADER__CURRENCY_SELECT__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.HEADER__DEPOSIT_BUTTON__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.FOOTER__MOBILE_APP__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.FOOTER__ANDROID_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.FOOTER__IOS_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__LOGIN__FORM__ERROR;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__LOGIN__FORM__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__WITHDRAW__FORM__REQUEST;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__MOBILE_APP_PAGE__ANDROID_APP_ICON__LINK__CLICK;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.MODAL__WITHDRAW__FORM__APPEARANCE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__PROMOCODE_ACTIVATION__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__PROMOCODE_ACTIVATION__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__TAB__SELECTION;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__ACTIVATE__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__ACTIVATE__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__CANCEL__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__CANCEL__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__BONUS_CARD__PLAY;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__EXCHANGE_CP_MODAL__EXCHANGE__SUCCESS;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.PROMO__EXCHANGE_CP_MODAL__EXCHANGE__FAILURE;
      attributes?: CommonAttributes;
    }
  | {
      name: AnalyticsEventName.GAME__FILTER__BUTTON__CLICK;
      attributes?: CommonAttributes;
    };

// export const pushAnalytics = factory((r) => (data: EventWithPayload) =>
//   r<null>('post', `${ANALYTICS_URL}/analytics`, snakify(data))
// )
export const pushAnalytics = (data: EventWithPayload) => Promise.resolve(null);

interface ABTesting {
  experiment: string;
  version: string;
  attributes: {
    sessionId: string;
    userId?: number;
    createdAt?: number; // field is required for the backend
    updatedAt?: number; // field is required for the backend
  };
}

// export const pushABTesting = factory((r) => (data: ABTesting) =>
//   r<null>('post', `${ANALYTICS_URL}/ab-testing`, snakify(data))
// );
export const pushABTesting = (data: ABTesting) => Promise.resolve(null);
